<template>
  <div class="pb-5">
    <p>{{ $t('kickout.explain') }}</p>
    <p>{{ $t('kickout.explain2') }}</p>
    <p>{{ $t('kickout.contact') }}</p>
		<base-button @click="goToLogin" class="mt-2">{{ $t('log-in') }}</base-button>
  </div>
</template>

<script>
import accountMixin from '@/mixins/account.mixin'

export default {
  mixins: [accountMixin],
  created () {
    this.$store.commit('setLoading', true)
    this.logOff(false)
    this.$store.commit('setLoading', false)
  },
	methods: {
		goToLogin () {
			this.$router.push('/inicio-sesion')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/views/account/Kickout.vue